import { Typography } from '@mui/material'
import CustomisedButton from '../../../components/button/button'
import { IFormInnerState } from '../form/IFormInnerState';
import ListItemSimple from '../../../components/card/listItem/listItemSimple';
import { useDispatch } from 'react-redux';
import { useAppBar } from '../../../components/appBar/appBarContext';
import { useEffect, useState } from 'react';
import { changeRouteType } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { v4 as uuid } from 'uuid'
import { useMutation } from 'react-query';
import { GetSalaryDeductionFormInfo, GoForward } from '../../../services/salaryDeduction.service';
import { IGetSalaryDeductionResponse } from '../../../models/salaryDeduction.model';
import { ApiResultModel } from '../../../models/common.model';
import AdditionalStepSkeleton from './additionalStepSkeleton';

export default function AdditionalStep({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const [value, setValue] = useState<IGetSalaryDeductionResponse>();
    // call services
    const { mutate: GetSalaryDeductionFormInfoMutation, isLoading } = useMutation(GetSalaryDeductionFormInfo, {
        onSuccess: (data: ApiResultModel<IGetSalaryDeductionResponse>) => {
            if (data.isSuccess) {
                setValue(data.data)
            }
        }
    });

    const { mutate: GoForwardInfoMutation } = useMutation(GoForward, {
        onSuccess: (data: ApiResultModel<boolean>) => {
            if (data.isSuccess) {
                setStep(uuid());
            }
        }
    });

    //end call services
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        setHeader(' فعالسازی', 'additionalStep');
        GetSalaryDeductionFormInfoMutation({ referenceKey: referenceKey! })
    }, []);
    const handleAdditionalStep = () => {
        GoForwardInfoMutation({ referenceKey: referenceKey! });

    }
    if (isLoading) {
        return (
            <AdditionalStepSkeleton />
        )
    }
    return (
        <div className="container-height-drawer">
            <div className="content-container">
                <div className='drawer-content'>
                    <div className="!mt-8"
                        dangerouslySetInnerHTML={{ __html: value?.htmlDescription || '' }}
                    >
                        { }
                    </div>

                    <div className='cursor-pointer'>
                        <ListItemSimple onClick={
                            () => {
                                if (value?.actionButtonRoute.startsWith('http://') || value?.actionButtonRoute.startsWith('https://')) {

                                    window.open(value?.actionButtonRoute, "_blank");
                                }
                                else {
                                    window.open(`http://${value?.actionButtonRoute}`, "_blank");
                                }
                            }
                        } title={value?.actionButtonTitle!} id={0} isShown={true} icon={<img src={`images/${value?.salaryDeductionProvider}.png`} alt={value?.salaryDeductionProviderTitle} style={{ color: 'var(--tirnary-text-color)' }} />} />
                    </div>
                </div>
                <div className="py-5">
                    <CustomisedButton
                        title={' ادامه'}
                        disable={false}
                        onClick={handleAdditionalStep}
                        type="submit"
                    />
                </div>
            </div>
        </div>
    )
}
